import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(route => route.meta.authRequired)

  if (!authRequired) return next()

  // if (!store.state['user/username'] || store.state['user/group']) {
  //   store.dispatch('user/fetchUser')
  // }

  if (Number(store.state['user/expireAt']) < Date.now()) redirectToLogin()

  // not secure, should request middle layer for user session
  if (store.getters['user/loggedIn']) return next()

  redirectToLogin()

  function redirectToLogin () {
    return next({ name: 'SignIn', params: { lang: to.params.lang }, query: { redirectFrom: to.fullPath } })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js